
import React, { Component } from 'react';
import {FormContext, FormProvider} from 'core/FormProvider';
import { YellowButton } from 'ui/Button';
import { UserContext } from 'components/User';
import {InputWidget} from "form/InputWidget";
import {ContextWidget} from "form/Contexed";
import FormGroup from 'form/FormGroup';


export default class AddConsigneeDialog extends Component {

  static contextType = UserContext;

  handlePostSave = (item) => {
    const { onClose, onAddOption } = this.props;
    onAddOption(item, true);
    onClose();
  };

  render() {
    return (
      <FormProvider
        url={'catalog/choice'}
        postSave={(item) => this.handlePostSave(item)}
        postSaveMessage={'Грузополучатель добавлен'}
        item={{
          department: this.context.data.department_active,
          type: 'CONSIGNEE'
        }}
      >
        <FormContext.Consumer>
        {context => {
          const { loading } = context;
          return (
            <React.Fragment>

              <FormGroup>
                <ContextWidget
                  name={'name'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Значение',
                    required: true
                  }}
                />

                <ContextWidget
                  name={'description'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Описание'
                  }}
                />

                <ContextWidget
                  name={'data.inn'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'ИНН'
                  }}
                />
              </FormGroup>

              <div className={'mt-30'}>
                <YellowButton
                  size={'large'}
                  onClick={(e) => context.handleSubmit(e)}
                  disabled={loading}
                >
                  Добавить
                </YellowButton>

              </div>
            </React.Fragment>
          )
        }}
        </FormContext.Consumer>
      </FormProvider>
    )
  }
}
